import React, { Component } from 'react';
import { connect } from "react-redux";
import Modal from 'react-modal';
import ProgressSpinnerSmall from '../../../common/ProgressSpinnerSmall';
import { DispatchHelpers, Selectors, TAG_USER_ROLES, TAG_USER_TYPES } from '../../../../data/tags';
import TagPermissions from '../../../common/tagsPermissions';
import ProgressOverlay from '../../../common/ProgressOverlay';
import ReactTable from 'react-table';
import Analytics from 'APP_ROOT/services/analytics';
import TagsTreeView from '../../../TagsTreeView';
import TagsTreeViewDropDown from '../../../TagsTreeViewDropDown';
import TagRolesDropDown from '../../../TagRolesDropDown';
import { strings } from '../../../../localization';
import ShareRavenModal from '../shareRavenModal';
import TagsList from '../../../TagsList';
import ConfirmDialog from '../../../common/ConfirmDialog';
import LambdaUtil from '../../../aws/lambda/lambdaUtil';
import Switch from '../../../common/Switch';
import TagsUtil, {TAG_ACTIONS} from '../../../common/tagsUtils';


class UsersPage extends Component {

    state = {
        dataSet: false,

        isUserTagsModalOpen: false,
        shareRavenModalOpen: false,
        isConfirmRemovePendingUserDialogOpen: false,

        removePendingUserInProgress: false,

        currentUser: null,
        users: undefined,
        filteredUsers: undefined,
        
        filters: [
            {id: 'status', value: 'active'} // Filter pending users by default
        ], // for users list

        filterUserTagsByKeyword: '', // For user tags list
        filterUserTagsByRole: '', // For user tags list

        successMessage: null,
        errorMessage: null
    }

    get showPendingUsers () {
        const statusFilter = this.state.filters.find(filter => filter.id === 'status');
        return statusFilter && statusFilter.value === 'all';
    }

    get hasPendingUsers () {
        return this.state.users.some(user => !user.userId);
    }

    componentDidMount() {
        Analytics.pageView();
        
        if(this.props.tags && this.props.ravens && this.props.users){
            this.setData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(!this.state.dataSet && this.props.tags && this.props.ravens && this.props.users){
            this.setData();
        }

        const prevStateStatusFilter = prevState.filters.find(filter => filter.id === 'status');
        if(prevStateStatusFilter.value === 'active' && this.showPendingUsers){
            this.scrollToPendingUsers();
        }
    }

    setData = () => {
        if(!this.props.tagsInheritedUsersAreSet){
            return;
        }

        TagPermissions.setData(this.props.user, {tags: this.props.tags, users: this.props.users, ravens: this.props.ravens});

        const tags = TagPermissions.getUserTags(this.props.user, this.props.accountDetails, this.props.tags);
        const users = TagPermissions.getUserUsers(this.props.user, this.props.accountDetails, this.props.users, tags, false);

        this.sortUsers(users);
        
        this.setState({ 
            tags, 
            users,
            filteredUsers: this.filterUsers(users, this.state.filters),
            dataSet: true
        });
    }

    sortUsers = (users) => {

        // sort users so that the ones that are assigned to the tag are at the top
        users.sort((a, b) => {
            if (a.isOwner && !b.isOwner) return -1;
            if (!a.isOwner && b.isOwner) return 1;
            if (a.isCurrentUser && !b.isCurrentUser) return -1;
            if (!a.isCurrentUser && b.isCurrentUser) return 1;
            if (a.userId && !b.userId) return -1;
            if (!a.userId && b.userId) return 1;
            return a.email.localeCompare(b.email);
        });
    }

    openUserTagsModal = (user) => {
        this.setState({ 
            isUserTagsModalOpen: true, 
            currentUser: user,
            errorMessage: null,
            successMessage: null
        });
    }

    openShareRavenModal = () => {
        this.setState({
            shareRavenModalOpen: true 
        });
    }

    openConfirmRemovePendingUserDialog = (user) => {
        this.setState({
            currentUser: user,
            isConfirmRemovePendingUserDialogOpen: true 
        });
    }

    closeUserTagsModal = () => {
        this.setState({ 
            isUserTagsModalOpen: false, 
            currentUser: null, 
            errorMessage: null, 
            successMessage: null,
            filterUserTagsByKeyword: ''
        });

        this.setData();
    }

    closeShareRavenModal = () => {
        this.setState({ 
            shareRavenModalOpen: false,
        });
    }

    closeConfirmRemovePendingUserDialog = () => {
        this.setState({
            currentUser: null,
            isConfirmRemovePendingUserDialogOpen: false,
        });
    }

    renderUserTagsModal = () => {
        const userTagsFiltered = this.filterUserTags();

        const userTags = this.state.currentUser.tags;
        const userTagsIds = userTags.map(tag => tag.tagId);
        const userInheritedTagsIds = userTags.filter(tag => tag.userType && tag.userType !== TAG_USER_TYPES.OWN_USER).map(tag => tag.tagId);
        const userPurelyInheritedTagsIds = userTags.filter(tag => tag.userType && tag.userType === TAG_USER_TYPES.INHERITED_USER).map(tag => tag.tagId);

        // User only has one tag or only one tag that is not purely inherited
        const showLastTagWarning = userTagsIds.length === 1 || (userTagsIds.length - userPurelyInheritedTagsIds.length === 1);

        const isCurrentUser = this.state.currentUser.email === this.props.user.email;
        
        return (
            <>
            <Modal 
                isOpen={this.state.isUserTagsModalOpen}
                className="tags-action-modal react-modal-content react-modal"
                overlayClassName="react-modal-overlay"
                shouldCloseOnOverlayClick={false}
                onRequestClose={this.closeUserTagsModal}
            >
                <div className="container-fluid">
                    <div className='row header'>
                        <div className='col-12'>
                            <h2>{strings.user} <span className='assigned-to'>{this.state.currentUser.email}</span></h2>
                        </div>
                        <div className='col-12'>                            
                            {this.state.successMessage && <div className='success-message'>{this.state.successMessage}</div>}
                            <ul className='errors'>
                                {this.state.errorMessage &&  <li className='error-message'>{this.state.errorMessage}</li>}
                            </ul>
                        </div>
                    </div>
                    <div className='row'>
                        {/* All the available tags  */}
                        <div className='col-6 col-xl-5'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h3>{strings.tags_available_tags}</h3>
                                </div>
                            </div>
                            <div className='row'>
                                {/* Tags Treeview*/ }
                                <div className='col-12'>
                                    <TagsTreeView 
                                        tags={this.state.tags}
                                        expandedTagsIds={userTagsIds}
                                        selectedTagsIds={userTagsIds}
                                        inheritedTagsIds={userInheritedTagsIds}
                                        multipleSelection={true}
                                        onChange={this.onUserTagsChange}
                                        resource={this.state.currentUser.email}
                                        isCurrentUser={isCurrentUser}
                                        showConfrimOnDeselect={true}
                                        lastTagWarning={strings.tags_user_last_tag_warning}
                                        showLastTagWarning={showLastTagWarning}
                                        disableGuestTags
                                        disableInheritedTags
                                        showTooltips
                                        compact
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Tags assigned to current user */}
                        <div className='col-6 col-xl-6 offset-xl-1'>
                            <div className="row header">
                                <div className='col-12'>
                                    <h3>{strings.tags_assigned_tags}</h3>
                                </div>
                            </div>
                            {/* Filter */}
                            <div className='row'>
                                <div className="col-12 filters">
                                    <input type="text" placeholder={strings.placeholder_filter} value={this.state.filterUserTagsByKeyword} onChange={(e) => this.setState({filterUserTagsByKeyword: e.target.value})} />
                                    <TagRolesDropDown 
                                        value={this.state.filterUserTagsByRole} 
                                        onChange={(e) => this.setState({filterUserTagsByRole: e.target.value})} 
                                    />
                                </div>
                            </div>
                             {/* list of user tags */}
                             <div className='row'>
                                <div className="col-12">
                                    <TagsList 
                                        isCurrentUser={isCurrentUser}
                                        listType="selecting"
                                        tags={userTagsFiltered}
                                        onSelectionChange={this.onUserTagSelectionChange}
                                        onRoleChange={this.onUserTagRoleChange}
                                        resource={this.state.currentUser.email}
                                        lastTagWarning={strings.tags_user_last_tag_warning}
                                        showLastTagWarning={showLastTagWarning}
                                        disableGuestTags
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 actions">
                            <button className="btn btn-outline-blue" onClick={this.closeUserTagsModal}><i className="material-icons">clear</i>{strings.app_close}</button>
                        </div>
                    </div>
                </div>
                {this.props.tagUsersChangesPending && <ProgressOverlay />}
            </Modal>
            </>
        );
    }

    onUserTagsChange = (selectedTagIds) => {

        const currentUser = this.state.currentUser;
        const currentTags = currentUser.tags;

        this.setState({ errorMessage: null, successMessage: null });
        
        // In each call there is only one change in selectedTags (add or remove)

        // Check if there is a new tag added
        const newTagId = selectedTagIds.find(tagId => !currentTags.some(ct => ct.tagId === tagId));

        if(newTagId){            
            this.addUserToTag(newTagId);
            return;
        }

        const deletedTag = currentTags.find(ct => !selectedTagIds.includes(ct.tagId));

        if(deletedTag){
            this.removeUserFromTag(deletedTag);
        }
    }

    onUserTagSelectionChange = (tag) => {

        this.setState({ errorMessage: null, successMessage: null});

        this.removeUserFromTag(tag);
    }

    onUserTagRoleChange = (tagToUpdate, role) => {
        const currentUser = this.state.currentUser;
        const roleString = strings[`tags_role_${role.toLowerCase()}_label`];
        this.setState({ errorMessage: null, successMessage: null});

        this.props.updateTagUser(tagToUpdate.tagId, currentUser, role)
        .then((updatedTag) => {
            TagPermissions.updateUserTagRole(currentUser, updatedTag, role);
            TagPermissions.updateUserTagsInheritance(currentUser);

            this.setState({ 
                currentUser,
                successMessage: strings.formatString(strings.tags_user_role_update_success, currentUser.email, roleString, updatedTag.name)
            });
        })
        .catch(error => {
            console.error(error);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.CHANGE_USER_ROLE, currentUser.email, roleString, tagToUpdate.name) });
        });
        
    }

    addUserToTag = (newTagId) => {
        const currentUser = this.state.currentUser;

        this.props.addTagUser(newTagId, currentUser, TAG_USER_ROLES.GUEST)
            .then((newTag) => {
                
                const newTagSubTags = this.state.tags.filter(tag => tag.ancestors.includes(newTag.tagId) && tag.tagId !== newTag.tagId);

                TagPermissions.addTagToUser(currentUser, newTag, newTagSubTags);

                // TagPermissions.updateUserTagsInheritance(currentUser);

                this.setState({ 
                    currentUser,
                    successMessage: strings.formatString(strings.tags_assign_success, currentUser.email, newTag.name)
                });
            })
            .catch(error => {
                console.error(error);
                const tag = this.state.tags.find(t => t.tagId === newTagId);
                this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.ASSIGN_USER, tag.name, currentUser.email) });
            });
    }

    removeUserFromTag = (tagToDelete) => {
        
        const currentUser = this.state.currentUser;

        this.props.deleteTagUser(tagToDelete.tagId, this.state.currentUser)
        .then((deletedTag) => {
            const deletedTagSubTags = this.state.tags.filter(tag => tag.ancestors.includes(deletedTag.tagId) && tag.tagId !== deletedTag.tagId);

            TagPermissions.removeTagFromUser(currentUser, deletedTag, deletedTagSubTags);

            // TagPermissions.updateUserTagsInheritance(currentUser);

            this.setState({ 
                currentUser,
                successMessage: strings.formatString(strings.tags_unassign_success, currentUser.email, deletedTag.name)
             });
        })
        .catch(error => {
            console.error(error);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.UNASSIGN_USER, tagToDelete.name, currentUser.email) });
        });
    }

    removePendingUser = () => {
        const {currentUser} = this.state;
        const {user} = this.props;

        const onError = (error) => {
            
            console.error(error);
            
            this.setState({
                successMessage: null,                
                removePendingUserInProgress: false,
                errorMessage: strings.formatString(strings.users_remove_pending_user_error, currentUser.email)
            });
        }

        const onSuccess = (result) => {
            const payload = JSON.parse(result.Payload);

            if(payload.status === 'ERROR'){
                onError(payload);
                return;
            }

            this.props.deleteUser(currentUser);
            const users = this.state.users.filter(u => u.email !== currentUser.email);
            this.setState({
                users,
                filteredUsers: this.filterUsers(users, this.state.filters),
                errorMessage: null,
                removePendingUserInProgress: false,
                successMessage: strings.formatString(strings.users_remove_pending_user_success, currentUser.email),
            });
        }

        
        this.closeConfirmRemovePendingUserDialog();

        this.setState({ removePendingUserInProgress: true });

        LambdaUtil.removeSharedRavenAccess(user.stage, currentUser.email, onSuccess, onError);
         
    }
    
    setListFilters = (filterId, value) => {

        let filters = [...this.state.filters];
        const indexOfFilter = filters.findIndex(filter => filter.id === filterId);
        
        if(filterId === 'status'){
            filters[indexOfFilter] = {
                id: filterId,
                value: filters[indexOfFilter].value === 'active' ? 'all' : 'active'
            };
        }


        if(filterId === 'email'){
            if(indexOfFilter > -1){
                if(value)
                    filters[indexOfFilter] = {id: filterId, value};
                else
                    filters = filters.filter(filter => filter.id !== filterId);
            }else{
                if(value)
                    filters = [...filters, {id: filterId, value}];
            }
        }

        if(filterId === 'tags'){
            if(indexOfFilter > -1){
                if(value.length > 0)
                    filters[indexOfFilter] = {id: filterId, value};
                else
                    filters = filters.filter(filter => filter.id !== filterId);
            }else{
                if(value.length > 0)
                    filters = [...filters, {id: filterId, value}];
            }
        }

        const filteredUsers = this.filterUsers(this.state.users, filters);

        this.setState({ filters, filteredUsers });
    }

    scrollToPendingUsers = () => {
        const firstPendingUserRow = document.querySelector('.in-list-info-message.pending-user');
        if(firstPendingUserRow){
            firstPendingUserRow.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
        }
    }

    filterUsers = (users, filters) => {
        let list = users || [];

        const emailFilter = filters.find(filter => filter.id === 'email');
        
        if(emailFilter){
            list = list.filter(user => user.email.toLowerCase().includes(emailFilter.value.toLowerCase()));
        }
        
        const tagsFilters = filters.find(filter => filter.id === 'tags');

        if(tagsFilters){
            const selectedTagsIds = tagsFilters.value;
            const noTagFilter = false; //this.state.filterByTagsOptions.find(option => option.checked && option.value === -1);

            if(selectedTagsIds.length > 0 || noTagFilter){

                list = list.filter(user => {
                    return user.tags.some(tag => selectedTagsIds.includes(tag.tagId)) || // If any of the selected tags is in the user tags
                        (noTagFilter && user.tags.length === 0); // If the user has no tags and the no tag filter is selected
                });
            }
        }

        const statusFilter = filters.find(filter => filter.id === 'status');
       
        if(statusFilter){
            if(statusFilter.value === 'active'){
                list = list.filter(user => user.userId);
            }
        }

        return list;
    }

    filterUserTags = () => {
        let list = this.state.currentUser.tags;

        if(this.state.filterUserTagsByKeyword){
            list = list.filter(tag => tag.name.toLowerCase().includes(this.state.filterUserTagsByKeyword.toLowerCase()));
        }

        if(this.state.filterUserTagsByRole){
            list = list.filter(tag => [tag.role, tag.inheritedRole].includes(this.state.filterUserTagsByRole));
        }

        return list;
    }
    
    renderStats = () => {
        
        const allUsers = this.state.users;

        if(!allUsers) return null;
        
        const stats = {
            total: allUsers.length,
            active: allUsers.filter(user => user.userId).length,
            pending: allUsers.filter(user => !user.userId).length,
        };

        return (
            <>
                <div className='col-12 stats'>
                    <div><label>{strings.stats_total_label}: </label><span>{stats.total}</span></div>
                    <div><label>{strings.stats_users_active}: </label><span>{stats.active}</span></div>
                    <div><label>{strings.stats_users_pending}: </label><span>{stats.pending}</span></div>
                </div>
                
            </>
        );
    }

    isContentReady = () => {
       const {tagsLoading, tagsError, tagsInheritedUsersAreSet, usersError} = this.props;
       const {dataSet} = this.state;

       if(tagsLoading || tagsError || usersError || !tagsInheritedUsersAreSet || !dataSet){
            return false;
       }

       if(this.props.users.length === 0 || this.state.users.length === 0){
            return false;
       }

        return true;
    }

    renderContentLoadingStatus = () => {
        let issue = null;

        // There is no error, no pending and no loaded tags. So, can conclude Tags are not enabled.
        const tagsNotEnabled = !this.props.tagsLoaded && !this.props.tagsLoading && !this.props.tagsError;

        if(tagsNotEnabled){
            issue = <div className='error-message'>{strings.tags_not_enabled}</div>;
        }
        else if(this.props.tagsError || this.props.usersError){
            console.error(this.props.tagsError, this.props.usersError);
            issue = <div className='error-message'><i className="material-icons">error_outline</i>{strings.loading_data_error}</div>;
        }
        else if(this.props.tagsLoading || !this.props.tagsInheritedUsersAreSet || !this.state.dataSet){
            issue = <div className='loading-data'><ProgressSpinnerSmall/><div>{strings.loading_data}</div></div>;
        }
        else if(this.props.users.length === 0 || this.state.users.length === 0){
            issue = <div className='info-message'>{strings.users_no_users_exists}</div>;
        }

        return issue;
    }

    render() {
        
        const isContentReady = this.isContentReady();

        return (
            <div id="usersPage" className='container account-page'>
                <div className='row'>
                    <div className='col-8'>
                        <h1>{strings.users_page_title}</h1>
                    </div>
                    <div className='col-4 d-flex align-items-end justify-content-end mb-3'>
                        <button className='btn' onClick={this.openShareRavenModal}><i className="material-icons">email</i>{strings.invite_user}</button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {this.state.successMessage && !this.state.isUserTagsModalOpen && <div className='success-message'>{this.state.successMessage}</div>}
                        {this.state.errorMessage && !this.state.isUserTagsModalOpen && <div className='error-message'>{this.state.errorMessage}</div>}
                    </div>
                </div>
                {isContentReady ?
                    <>
                        <div className='row'>
                            {this.renderStats()}
                        </div>
                        <div className='row'>
                            <div className='col-6 instructions'>
                                <span>{strings.formatString(strings.tags_click_to_manage_x_tags, strings.user, <i className="material-icons tag-edit-icon">edit</i>)}</span>
                            </div>
                            <div className='col-6 show-pending-users-switch'>
                                {this.hasPendingUsers &&
                                <>
                                    <Switch
                                        checked={this.showPendingUsers}
                                        onChange={() => this.setListFilters('status')}
                                        smallFormat 
                                    />
                                    <span className="checkbox-span">{strings.users_show_pending_users}</span>
                                </>
                                }                
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <UsersTable 
                                    users={this.state.filteredUsers}
                                    tags={this.state.tags}
                                    filters={this.state.filters}
                                    setListFilters={this.setListFilters}
                                    openUserTagsModal={this.openUserTagsModal}
                                    openConfirmRemovePendingUserDialog={this.openConfirmRemovePendingUserDialog}
                                />
                                {this.state.isUserTagsModalOpen && this.renderUserTagsModal()}
                            </div>
                        </div>
                        <ShareRavenModal
                            tags={this.state.tags}
                            users={this.props.users} // original list of users (to check if the invited user already exists on account or not)
                            stage={this.props.user.stage}
                            shareRavenModalOpen={this.state.shareRavenModalOpen}
                            closeShareRavenModal={this.closeShareRavenModal}
                        />

                        {this.state.isConfirmRemovePendingUserDialogOpen && 
                            <ConfirmDialog
                                isOpen={true}
                                onOk={this.removePendingUser}
                                onCancel={this.closeConfirmRemovePendingUserDialog}
                                onDismiss={this.closeConfirmRemovePendingUserDialog}
                            >
                                <h4>{strings.users_remove_pending_user_confirm_title}</h4>
                                <p>{strings.formatString(strings.users_remove_pending_user_confirm_message, this.state.currentUser.email)}</p>
                            </ConfirmDialog>
                        }
                        
                        {this.state.removePendingUserInProgress && <ProgressOverlay />}
                    </>
                :
                    <div className='row'>
                        <div className='col-12'>
                            {this.renderContentLoadingStatus()}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

class UsersTable extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            columns: this.getColumns()
        }
    }

    newColumn = (header, accessor, overrides = {} ) => {
        return {
            Header: strings[`users_page_list_header_${header}`],
            accessor: accessor,
            Placeholder: strings.formatString(strings.reports_header_filter_x_names, strings.user),
            filterable: false,
            className: 'react-table-column',
            headerClassName: 'react-table-column',
            ...overrides
        }
    }

    getColumns = () => {
        const {tags, openUserTagsModal, openConfirmRemovePendingUserDialog} = this.props;

        const columns = [
            this.newColumn('email', 'email',
            {
                filterable: true,
                className: 'react-table-column user-email-column',
                headerClassName: 'react-table-column user-email-column',
                Cell: row => <span title={row.value} className='user-email'>{row.value}</span>
            }),
            this.newColumn('tags', 'tags',
            {
                filterable: true,
                className: 'react-table-grow-column',
                headerClassName: 'react-table-grow-column',
                Filter: ({filter, onChange}) => {
                    return <div className='list-filter-by-tags-select'>
                            <TagsTreeViewDropDown
                                tags={tags}
                                placeholder={strings.tags_filter_by_tags}
                                multipleSelection={true}
                                selectedTagsIds={filter ? filter.value : []}                                
                                onChange={(selectedTagsIds) => onChange(selectedTagsIds)}                                
                                showConfrimOnDeselect={false}
                                className='react-table-header-filter'
                                compact
                            />
                        </div>
                },
                Cell: row => {
                    if(!row.original.userId){
                        return <span className='in-list-info-message pending-user'><i className="material-icons">schedule</i> {strings.users_pending_invitation}</span> 
                    }

                    return row.original.isOwner ? 
                            <span className='in-list-info-message'>{strings.tags_owner_has_access_to_all_tags}</span> 
                        : 
                            <TagsList linear={true} tags={row.value} showMore={true} onMore={() => openUserTagsModal(row.original)} />
                }
            }),
            this.newColumn('', undefined, {
                Cell: row => {
                    if(!row.original.userId){
                        return <button onClick={() => openConfirmRemovePendingUserDialog(row.original)} className='btn-icon btn-outline-transparent' title={strings.users_remove_pending_user}><i className="material-icons remove-pending-user">unsubscribe</i></button>
                    }

                    return <button disabled={row.original.isOwner} onClick={() => openUserTagsModal(row.original)} className='btn-icon btn-outline-transparent'><i className="material-icons">edit</i></button>
                },
                width: 50
            })
        ];

        return columns;
    }

    render() {
        const {users, filters, setListFilters} = this.props;

        return <ReactTable
                filterable={true}
                sortable={false}
                showPagination = {false}
                minRows = {0}
                pageSize = {users.length}
                data={users}
                noDataText={strings.no_match_for_selected_filters}
                filtered={filters}
                defaultFilterMethod={(filter, row) => {
                    return true;
                }}
                columns={this.state.columns}
                getTrProps={(state, rowInfo, column) => {
                    return { className: '-rollup'};
                }}
                onFilteredChange={(filtered, column, value) => {
                    setListFilters(column.id, value);
                }}
            />
    }
}

const mapStateToProps = state => {
    return {
        tagUsersChangesPending: Selectors.tagPropChangePending(state), // A prop of a tag is being changed (tag.name, tag.type, tag.users, ...)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        deleteTagUser: (tagId, user) => dispatch(DispatchHelpers.deleteTagUser(tagId, user)),
        addTagUser: (tagId, user, role) => dispatch(DispatchHelpers.addTagUser(tagId, user, role)),
        updateTagUser: (tagId, user, role) => dispatch(DispatchHelpers.updateTagUser(tagId, user, role)),
    }

};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);